import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dialog-close-button',
  templateUrl: './dialog-close-button.component.html',
  styleUrls: ['./dialog-close-button.component.scss'],
  standalone: false
})
export class DialogCloseButtonComponent {
  @Output()
  buttonClick: EventEmitter<void> = new EventEmitter();
}
